<template>
    <div class="bg-lightest col-sm-12 py-4 mt-4">
        <div class="options d-flex align-items-center">

            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-12 mt-3">
                        <div class="row">

                            <div class="d-flex col-sm-2 pl-0">
                                <div class="d-flex w-100">
                                    <input class="bg-lighter w-100" type="text" v-model="getInvoicePageFilters.string" placeholder="Search invoice" @input="searchDebounced">
                                </div>
                            </div>

                            <div class="col-sm-8 row align-items-center">
                                <button class="btn blue" @click="search">Search</button>
                            </div>

                            <div class="col-sm-2">
                                <div class="d-flex justify-content-end">
                                    <export :exportOptions="exportOptions"></export>
                                </div>
                            </div>

                            <!-- <div class="col-sm-8 d-flex">

                                <button class="btn wider blue" @click='getReservationsPaginated'>Search</button>
                                <button class="btn wider tertiary ml-3" @click='clearFilters'>Clear all filters</button>

                            </div>

                            <div class="col-sm-2">
                                <div class="d-flex justify-content-end">
                                    <export :exportOptions="exportOptions"></export>
                                </div>
                            </div> -->

                        </div>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <div class="row">

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="editedAgentList && editedAgentList.length > 0">
                                <seller-picker class="w-100" ref="sellerSelector" :allowEmpty="true" :inlcudeWidget="false" :showMyTeam="true" :myTeamList="sellerPicerkMyTeam" @input="sellerChanged" @deselect="deselectSeller"></seller-picker>
                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="getInvoiceTypes">
                                <v-select :searchable="true" :options="treatedInvoiceTypes" label="label" placeholder="All" v-model="filterType" @input="changeInvoiceType"></v-select>
                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="getSlimFilters">
                                <v-select :searchable="true" :options="treatedProductList" label="name" placeholder="All" v-model="filterProduct" @input="changeProductFilter"></v-select>
                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="getInvoiceTargetTypes">
                                <v-select :searchable="true" :options="treatedInvoiceTargets" label="label" placeholder="All" v-model="filterTargetType" @input="changeInvoiceTargetType"></v-select>
                            </div>
                            <div class="col-md-2 row align-items-center">
                            <!-- <button class="btn blue" @click="search">Search</button> -->
                            <button class="ml-3 btn tertiary" @click="clearFilters">Clear</button>
                        </div>



                        </div>
                    </div>

                    <!-- Buttons row -->



                </div>
            </div>




        </div>

    </div>
</template>

<script>
import { mapActions, mapGetters} from 'vuex'
import extendedVSelect from '@/extends/vue-select'
import Export from '@/tools/ExportV2'
import SellerPicker from '@/tools/SellerPicker'
export default {
    data: function () {
        return {
            exportOptions: [
                {
                    label: 'Excel',
                    action: this.getExcel
                }
            ],
            filterProduct: {
                id:null,
                name:'All Products'
            },
            filterType: {
                id: null,
                label: "All Documents"
            },
            filterTargetType: {
                id: null,
                label: "Billed to"
            },
            filterCounters: {
                seller: 0,
                documentType: 0,
                product: 0,
                billedTo: 0
            },
        }
    },
    created: function () {
        this.clearInvoicePageFilters()
    },
    computed: {
        ...mapGetters([
            'getInvoicePageFilters',
            'getSlimFilters',
            'getAgents',
            'getInvoiceTargetTypes',
            'getInvoiceTypes',
        ]),
        treatedProductList: function() {
            let output = JSON.parse(JSON.stringify(this.getSlimFilters.productList));

            output.unshift({
                id:null,
                name:'All Products'
            })
            return output
        },
        editedAgentList: function() {
            let agentList = JSON.parse(JSON.stringify(this.getAgents));


            let agentMustHaveName = agentList.filter(agent => {
                return agent.name != null
            })

            agentMustHaveName.unshift(this.agentMe)
            agentMustHaveName.unshift({
                id: null,
                brandName: 'All Agent/Seller'
            })

            return agentMustHaveName;
        },
        treatedInvoiceTypes: function () {
            let allTypes = JSON.parse(JSON.stringify(this.getInvoiceTypes))
            allTypes.unshift({
                id: null,
                label: "All Documents"
            })

            return allTypes
        },
        treatedInvoiceTargets: function () {
            let allTargets = JSON.parse(JSON.stringify(this.getInvoiceTargetTypes))
            allTargets.unshift({
                id: null,
                label: "Billed to"
            })

            return allTargets
        },
        sellerPicerkMyTeam: function () {
            return [
                {
                    brandName:'My team',
                    isAllMyTeam: true
                }
            ]
        }
    },
    methods: {
        ...mapActions([
            'clearInvoicePageFilters',
            'downloadInvoiceList',
            'exportInvoicePageExcel',
            'clearInvoicePageFilters',
        ]),
        searchDebounced: _.debounce( function(){
                this.search()
            },
            500
        ),
        search: function(){
            this.downloadInvoiceList()
        },
        clearFilters: function() {

            this.seller = null
            this.selectedSeller = null
            this.filterType = null
            this.filterProduct = null
            this.filterTargetType = null
            this.resetFilterCounter()


            if(this.$refs.sellerSelector){
                this.$refs.sellerSelector.deselectSeller()
            }
            this.clearInvoicePageFilters()
            this.downloadInvoiceList()

        },
        resetFilterCounter: function () {
            // this.$set(this.filterCounters, 'seller', -1)
            this.$set(this.filterCounters, 'documentType', -1)
            this.$set(this.filterCounters, 'product', -1)
            this.$set(this.filterCounters, 'billedTo', -1)
        },
        getExcel: function() {
            this.exportInvoicePageExcel().then(response => {
                // console.log(response);
                // this.openByteArrayNewTab(response.data)
            })
        },
        changeProductFilter: function() {
            // counter
            this.filterCounters.product++

            if(this.filterProduct){
                this.getInvoicePageFilters.productId = this.filterProduct.id
            } else {
                this.getInvoicePageFilters.productId = null
                this.filterProduct = {
                    id:null,
                    name:'All Products'
                }
            }

            // load invoices after changing filter (if statement is to prevent searching o created)
            console.log('changeProduct - this.disableSearch', this.disableSearch);
            if(this.filterCounters.product > 1){
                this.search()
            }

        },
        changeInvoiceType: function() {
            // counter
            this.filterCounters.documentType++

            if(this.filterType){
                this.getInvoicePageFilters.invoiceType = this.filterType.id
            } else {
                this.getInvoicePageFilters.invoiceType = null
                this.filterType = {
                    id: null,
                    label: "All documents"
                }
            }

            // load invoices after changing filter (if statement is to prevent searching o created)
            if(this.filterCounters.documentType > 1){
                this.search()
            }
        },
        changeInvoiceTargetType: function() {
            // counter
            this.filterCounters.billedTo++

            if(this.filterTargetType){
                this.getInvoicePageFilters.targetType = this.filterTargetType.id
            } else {
                this.getInvoicePageFilters.targetType = null
                this.filterTargetType = {
                    id: null,
                    label: "Billed to"
                }
            }

            // load invoices after changing filter (if statement is to prevent searching o created)
            if(this.filterCounters.billedTo > 1){
                this.search()
            }
        },
        sellerChanged: function(e) {
            // counter
            this.filterCounters.seller++

            //resets before apply
            this.getInvoicePageFilters.onlyMyTeam = false
            this.getInvoicePageFilters.agentId = null
            this.getInvoicePageFilters.userId = null
            this.getInvoicePageFilters.channelType = null

            if(e.isAllMyTeam){
                this.getInvoicePageFilters.channelType = 0
                // this.getInvoicePageFilters.onlyMyTeam = true
            } else if(e.userAccountTypes){
                // console.log('My team member');
                this.getInvoicePageFilters.userId = e.id
            } else if(e.channelType == 101) {
                // console.log('is widget');
                this.getInvoicePageFilters.channelType = 101 //sets filter for widget
                return true
            } else if(e.isAllSellers) {
                // console.log('is widget');
                this.selectedSeller = {
                    id: null,
                    brandName: 'All Agent/Seller'
                }
                return true
            } else {
                this.getInvoicePageFilters.userId = null
                this.getInvoicePageFilters.agentId = e.id
            }

            // this.getInvoicePageFilters.channelType = null //remove filter for widget

            // load invoices after changing filter
            this.search()
        },
        deselectSeller: function() {
            this.getInvoicePageFilters.userId = null
            this.getInvoicePageFilters.agentId = null
        }
    },
    watch: {
        getInvoicePageFilters: {
            handler: function (newVal, oldVal) {
                console.log('filters changed', newVal, oldVal);
            },
            deep: true
        }
    },
    components: {
        Export,
        vSelect: extendedVSelect,
        SellerPicker
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Filters.vue?905985d8